import "./index.less";
import { QRCodeSVG } from "qrcode.react";
import { useLocation } from "react-router-dom";
const ScanToPay = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const orderId = params.get("orderId") || "";
  const orderCategory = params.get("orderCategory") || "";
  const hostname = window.location.hostname;
  let qrCodeURL = `https://${hostname}/mcp/jumpToApp?orderId=${orderId}`;
  if (orderCategory === 'ECS') {
    qrCodeURL = `https://${hostname}/mcp/jumpToApp?orderId=${orderId}&orderCategory=${orderCategory}`;
  }
  return (
    <div className="scan-page-container">
      <div className="scan-content-container">
        <img
          alt="title"
          src={"https://img.mcd.cn/gallery/e1f8b901ca38dabf.png"}
          className="scan-content-title"
        />
        <div className="scan-content-qrcode">
          <img
            alt="qrcode border"
            src={"https://img.mcd.cn/gallery/0db14dd418f051a3.png"}
            className="scan-content-qrcode-border"
          />
          <QRCodeSVG value={qrCodeURL} className="scan-content-qrcode-code" />
        </div>
        <img
          alt="subtitle"
          className="scan-content-subtitle"
          src="https://img.mcd.cn/gallery/df8015bca982a9d0.png"
        />
      </div>
    </div>
  );
};

export default ScanToPay;
